import { Affix, Group, Paper, Portal, useMantineTheme } from '@mantine/core';
import {
  createContext,
  useContext,
  useCallback,
  useState,
  type ReactNode,
  type RefObject,
} from 'react';

const ControlsContext = createContext<HTMLDivElement | null>(null);

export const GraphControls = ({
  children,
  controlsRef,
}: {
  children?: ReactNode;
  controlsRef?: RefObject<HTMLDivElement | null>;
}) => {
  const theme = useMantineTheme();
  const [target, setTarget] = useState<HTMLDivElement | null>(null);
  const attach = useCallback(
    (element: HTMLDivElement | null) => {
      if (controlsRef) controlsRef.current = element;
      setTarget(element);
    },
    [controlsRef],
  );
  return (
    <ControlsContext.Provider value={target}>
      {children}
      <Affix
        position={{ top: 0, left: '50%' }}
        className='!absolute -translate-x-1/2'
        withinPortal={false}
        zIndex={1}
      >
        <Paper
          p={6}
          withBorder
          radius={theme.defaultRadius}
          className='[&:has(>div:empty)]:hidden'
        >
          <Group
            gap='xs'
            ref={attach}
            wrap='nowrap'
            data-testid='graph-controls'
          />
        </Paper>
      </Affix>
    </ControlsContext.Provider>
  );
};

export const GraphControlsPortal = ({ children }: { children: ReactNode }) => {
  const target = useContext(ControlsContext);
  return target ? <Portal target={target}>{children}</Portal> : null;
};
